import Box from '@repo/ui/box'
import Button from '@repo/ui/button'
import { DetailedList } from '@repo/ui/detailed-list'
import { ListApprovedIcon, PinIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

import { LanguageTestSubmissionStep } from '../../../../lib/types/enums/language-test-submissions/language-test-submission-step'
import useLanguageTest from '../../../../views/client-personal-space/informations/context/use-language-test'
import { ClientHeader } from './shared-client-space-ui'

const pageheaders: string[] = [
  'Merci de compléter ce QCM « Test de niveau » afin de nous aider à déterminer ton niveau de langue.',
  'Avant de commencer le test, quelques recommandations :'
]

const pageDetails: string[] = [
  '<strong>Utilise de préférence un PC avec le navigateur Chrome</strong>',
  "<strong>Assure-toi de ne pas ouvrir d'autres onglets</strong>",
  "Assure-toi de commencer le test peu de temps après t'être connecté(e) à cet Espace Personnel, sinon déconnecte toi et reconnecte toi avant de commencer.",
  'Tu as <strong>60 minutes maximum pour compléter le test</strong>, mais tu peux bien entendu le faire plus rapidement. Au bout de ces 60 minutes, le test s´arrêtera et sera automatiquement transmis à LEC',
  '<strong>Une fois le test commencé, tu ne pourras pas le mettre en pause pour le reprendre plus tard</strong>',
  '<strong>Assure-toi donc d´avoir une heure devant toi,</strong> au calme et sans être dérangé, avant de cliquer sur « Commencer le test ».',
  'A la fin des questions, clique sur « Terminer le test » puis « Envoyer à LEC »',
  '<strong>Ne te fais pas aider :</strong> le test doit refléter ton vrai niveau de langue',
  'Ce test est proposé, à l´identique, aussi bien aux collégiens qu´aux lycéens. En fonction de ton nombre d´années d´études de la langue, les questions seront de plus en plus difficiles : ne t´inquiète surtout pas si tu ne réponds pas à certaines questions que tu ne comprends pas.',
  '<strong>Tu peux sauter les questions difficiles et tenter d´y revenir plus tard s´il te reste du temps à la fin du questionnaire</strong>'
]

const LanguageTestInstructions = () => {
  const { startTest, isStartingTest, step } = useLanguageTest()

  return (
    <Box className="flex flex-col gap-6 p-4 mobile:p-0 mobile:gap-4 mobile:mb-16">
      <ClientHeader title={'Test de niveau'} icon={ListApprovedIcon} />

      <DetailedList
        icon={PinIcon}
        headers={pageheaders}
        details={pageDetails.map((text) => ({ text, displayArrow: true }))}
      />

      <Typography variant="secondary-body">
        Tu es prêt(e) ? Alors clique sur « Commencer le test » !
      </Typography>

      <div className="flex justify-end mobile:absolute mobile:bottom-0 mobile:right-0 mobile:w-full mobile:bg-white mobile:p-4 rounded-t-xl mobile:shadow">
        <Button
          loading={isStartingTest}
          disabled={step === LanguageTestSubmissionStep.LOCKED}
          onClick={startTest}
          className="w-fit self-end mobile:w-full"
          label="Commencer le test"
        />
      </div>
    </Box>
  )
}

export default LanguageTestInstructions
